export default "__VITE_ASSET__DCjvsgld__"